import { Link } from "react-router-dom";
import { Instagram, Mail, Phone, MapPin } from "lucide-react";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="gradient-navy text-primary-foreground">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 rounded-full gradient-gold flex items-center justify-center font-bold text-accent-foreground text-sm">3D</div>
              <span className="font-bold text-lg">{t("footer.brand")}</span>
            </div>
            <p className="text-primary-foreground/70 text-sm leading-relaxed">{t("footer.desc")}</p>
            <div className="mt-4">
              <a href="https://www.instagram.com/wypukle.pl/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 gradient-gold text-accent-foreground font-semibold px-4 py-2.5 rounded-lg hover:opacity-90 transition-opacity shadow-gold text-sm">
                <Instagram className="w-5 h-5" />
                @wypukle.pl
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-accent">{t("footer.navigation")}</h4>
            <div className="flex flex-col gap-2 text-sm text-primary-foreground/70">
              <Link to="/" className="hover:text-primary-foreground transition-colors">{t("nav.home")}</Link>
              <Link to="/produkty" className="hover:text-primary-foreground transition-colors">{t("nav.products")}</Link>
              
              <Link to="/o-nas" className="hover:text-primary-foreground transition-colors">{t("nav.about")}</Link>
              <Link to="/baza-wiedzy" className="hover:text-primary-foreground transition-colors">{t("nav.knowledge")}</Link>
              <Link to="/blog" className="hover:text-primary-foreground transition-colors">{t("nav.blog")}</Link>
              <Link to="/kontakt" className="hover:text-primary-foreground transition-colors">{t("nav.contact")}</Link>
            </div>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-accent">{t("footer.contact")}</h4>
            <div className="flex flex-col gap-3 text-sm text-primary-foreground/70">
              <a href="mailto:biuro@projekt-art.pl" className="flex items-center gap-2 hover:text-primary-foreground transition-colors">
                <Mail className="w-4 h-4 text-accent" /> biuro@projekt-art.pl
              </a>
              <a href="tel:+48534900620" className="flex items-center gap-2 hover:text-primary-foreground transition-colors">
                <Phone className="w-4 h-4 text-accent" /> +48 534 900 620
              </a>
              <span className="flex items-center gap-2">
                <MapPin className="w-4 h-4 text-accent" /> ul. Głogowa 39, 40-750 Katowice
              </span>
              <span className="block pt-1 leading-relaxed">
                DRUKEXPERT.PL Sp. z o.o.<br />
                NIP: 954 287 50 30
              </span>
            </div>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-accent">{t("footer.hours")}</h4>
            <div className="text-sm text-primary-foreground/70 space-y-1">
              <p>{t("footer.weekdays")}</p>
              <p className="text-primary-foreground font-medium">{t("footer.weekdaysHours")}</p>
              <p className="mt-3">{t("footer.weekend")}</p>
              <p className="text-primary-foreground/50">{t("footer.closed")}</p>
              <p className="mt-3 text-accent font-medium">✉ {t("footer.emailContact")}</p>
            </div>
          </div>
        </div>

        <div className="border-t border-primary-foreground/10 mt-12 pt-8 flex flex-col items-center gap-4 text-xs text-primary-foreground/50">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 w-full">
            <p>{t("footer.rights")}</p>
            <div className="flex gap-6">
              <Link to="/polityka-prywatnosci" className="hover:text-primary-foreground transition-colors">{t("footer.privacy")}</Link>
              <Link to="/polityka-cookies" className="hover:text-primary-foreground transition-colors">{t("footer.cookies")}</Link>
            </div>
          </div>
          <p>{t("footer.owner")}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
